module.exports = __webpack_public_path__ + "img/car-clr-4.6b8132de.png";